import { margins } from '@olist/styled-system';
import styled, { css } from 'styled-components';
import Caption from '../../Text/Caption/Caption.js';
import '../../Text/DetailedSubheading/DetailedSubheading.js';
import '../../Text/OverlineLg/OverlineLg.js';
import '../../Text/OverlineMd/OverlineMd.js';
import '../../Text/ParagraphLg/ParagraphLg.js';
import ParagraphMd from '../../Text/ParagraphMd/ParagraphMd.js';
import '../../Text/SectionHeading/SectionHeading.js';
import '../../Text/SectionSubheading/SectionSubheading.js';
import '../../Text/Title/Title.js';

const Wrapper = styled.ul(({ theme: { olist: { components: { table }, }, }, }) => css `
    border: ${table.mobile['border-width']} solid
      ${table.mobile['border-color']};
    border-radius: ${table.mobile.radius};

    list-style: none;
    padding: 0;
    ${margins}
  `);
const TableCell = styled.div(({ theme: { olist: { components: { table }, }, }, }) => css `
    margin-bottom: ${table.mobile.cell['margin-bottom']};

    ${Caption} {
      margin-bottom: ${table.mobile.heading['margin-bottom']};
    }

    ${ParagraphMd} {
      color: ${table.mobile.cell.color};
    }
  `);
const TableCard = styled.li(({ theme: { olist: { components: { table }, }, }, }) => css `
    position: relative;
    padding: ${table.mobile.card.padding};

    & + & {
      border-top: ${table.mobile['border-width']} solid
        ${table.mobile['border-color']};
    }
  `);
const DetailedContent = styled.div(({ theme: { olist: { components: { table }, }, }, }) => css `
    border-top: ${table.mobile['border-width']} solid
      ${table.mobile['border-color']};
    padding-top: ${table.mobile.detailedContent['padding-top']};
  `);

export { DetailedContent, TableCard, TableCell, Wrapper };
